export default __webpack_public_path__ + "static/media/330_dummy2016-nagelstudio01-de.3166c064.png";